/**
 * Cesium scene modes
 */
export enum SceneMode {
  SCENE3D,
  COLUMBUS_VIEW,
  SCENE2D,
  PERFORMANCE_SCENE2D
}
